import {Directive, ElementRef, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: 'form'
})
export class FormDirective implements OnInit {
    constructor(private elementRef: ElementRef,
                private renderer2: Renderer2) {
    }

    ngOnInit(): void {
        this.renderer2.listen(this.elementRef.nativeElement, 'submit', (event) => {
            this.renderer2.addClass(this.elementRef.nativeElement, 'ng-submitted');
        });
        this.renderer2.listen(this.elementRef.nativeElement, 'reset', (event) => {
            this.renderer2.removeClass(this.elementRef.nativeElement, 'ng-submitted');
        });
    }
}
